import { CheckCircle2, CreditCard, LayoutDashboard, Monitor, Users } from 'lucide-react';
import { SpaceListItem } from '../../hooks/useAdminSpaces';
import { DetailBadge } from './DetailBadge';

interface CardContentProps {
  space: SpaceListItem;
  onEdit: (id: string) => void;
}

export function CardContent({ space, onEdit }: CardContentProps) {
  const capacities = space._count?.capacityBrackets ?? 0;
  const layouts = space._count?.roomLayouts ?? 0;
  const equipments = space._count?.equipments ?? 0;
  const pricingGroups = space._count?.pricingGroups ?? 0;

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
          <h3
            onClick={() => onEdit(space.id)}
            style={{
              fontSize: '1.25rem',
              fontWeight: 800,
              color: '#00303c',
              marginBottom: '0.25rem',
              cursor: 'pointer',
              lineHeight: 1.2,
              transition: 'color 0.2s ease',
            }}
          >
            {space.name}
          </h3>
          <div style={{ color: '#00758d', fontSize: '0.85rem', fontWeight: 600, marginBottom: '0.75rem' }}>
            {space.category}
          </div>
        </div>
      </div>

      <div
        style={{
          fontSize: '0.85rem',
          color: '#666',
          lineHeight: 1.5,
          marginBottom: '1rem',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {space.description || space.shortDesc || 'Aucune description fournie pour le moment.'}
      </div>

      {/* Space details badges */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '1rem', marginBottom: '1rem' }}>
        <DetailBadge icon={<Users size={14} />} color="#00758d" bgColor="rgba(0,117,141,0.08)" label={`${capacities} Forfaits`} />
        <DetailBadge icon={<LayoutDashboard size={14} />} color="#8E0B56" bgColor="rgba(142,11,86,0.08)" label={`${layouts} Configurations`} />
        <DetailBadge icon={<Monitor size={14} />} color="#00303c" bgColor="rgba(0,48,60,0.08)" label={`${equipments} Équipements`} />
        <DetailBadge icon={<CreditCard size={14} />} color="#dfc32f" bgColor="rgba(223,195,47,0.15)" label={`${pricingGroups} Tarifications`} />
      </div>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
        {space.allowMultiDay && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', fontSize: '0.75rem', color: '#666' }}>
            <CheckCircle2 size={12} color="#10b981" /> Multi-jours autorisés
          </div>
        )}
      </div>
    </>
  );
}
